import React from 'react'
import { useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'
import {useParams} from 'react-router-dom'

import {withTitle} from '@/router/utils'
import {OutletDetailsContainer} from '@/components'

export const OnlineOutletDetailsStoreSymbol = Symbol('OnlineOutletDetailsStoreSymbol')

const OnlineOutletDetails: React.FC<null> = observer(() => {
    const { t } = useTranslation()
    const {id} = useParams<{id: string}>()

    return (
        <OutletDetailsContainer
            id={id}
            injectableIdentifier={OnlineOutletDetailsStoreSymbol}
            containerTitle={t('OnlineOutletDetails.onlineOutlets')}
        />
    )
})

export default withTitle(OnlineOutletDetails, 'OnlineOutletDetails.onlineOutlets')
